import { useState, useRef, useEffect } from "react";
import { QuestionIcon } from "./Constants/Icons";

const ReportBug = () => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function onClickOutside(e) {
      if (
        isOpen &&
        containerRef.current &&
        !containerRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [isOpen]);

  useEffect(() => {
    console.log(isOpen);
  }, [isOpen]);

  return (
    <div ref={containerRef} className="position-fixed bottom-[24px] right-[24px] z-50 flex flex-col items-end">
      {isOpen && (
        <div className="w-[280px] p-[16px] bg-[#9a016a] flex flex-col rounded-lg shadow-lg animate-fade-in-up mb-[8px]">
          <p className="text-[18px] text-left text-[#F0F0F0] font-proximanova mb-0" style={{ lineHeight: '1.35' }}> If you have any questions, please feel free to reach out to us!</p>

          <a
            href="mailto:marketplace@charmhealth.com"
            className="text-[18px] text-left text-[#F0F0F0] font-proximanova underline hover:text-gray-200 break-words"
            style={{ lineHeight: '1.35' }}>
            marketplace@charmhealth.com
          </a>
        </div>
      )}

      <button className="hover:scale-110 hover:shadow-xl transition-transform duration-300 ease-out" onClick={() => setIsOpen(!isOpen)}>
        <QuestionIcon />
      </button>
    </div>
  );
};

export default ReportBug;
